/**
 * Совместимость фитингов подключений с корпусом гидроразделителя.
 * Правила совпадают с логикой выбора в редакторе.
 */
import fittingsData from '../fittingsData';

/**
 * Проверка совместимости фитинга с диаметром основной трубы
 * 
 * Для трубы 42.4мм:
 * - Ниппели: только до 3/4 включительно
 * - Муфты: только до 1/2 включительно
 * - Фланцы: запрещены все
 * - Накидные гайки: только 1"
 * - Шайбы с наружной резьбой: только 1"
 * 
 * Для трубы 48.3мм:
 * - Ниппели: только до 3/4 включительно
 * - Муфты: только до 3/4 включительно
 * - Фланцы: запрещены все
 * - Накидные гайки: только 1"
 * - Шайбы с наружной резьбой: только 1"
 * 
 * Для трубы 60.3мм:
 * - Ниппели: только до 1" включительно
 * - Муфты: только до 1" включительно
 * - Фланцы: только Ду25 (приварная труба 33,7 мм)
 * - Накидные гайки: только до 1 1/2" включительно
 * - Шайбы с наружной резьбой: только до 1 1/2" включительно
 * 
 * Для трубы 76.1мм:
 * - Ниппели: только до 1 1/2 включительно
 * - Муфты: только до 1 1/4 включительно
 * - Фланцы: только до Ду40 включительно
 * - Накидные гайки: разрешены все
 * - Шайбы с наружной резьбой: разрешены все
 */
export const isFittingCompatibleWithMainPipe = (fittingId, mainPipeDiameter) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // ========== Ограничения для трубы 42.4мм ==========
  if (mainPipeDiameter === 42.4) {
    // Ниппели: запрещены больше 3/4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1/2
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_1_1.4' || fittingId === 'Nak_Gaika_1_1.2' || fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_1_1.4' || fittingId === 'Shaib_Nar_Rezba_1_1.2' || fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для трубы 48.3мм ==========
  if (mainPipeDiameter === 48.3) {
    // Ниппели: запрещены больше 3/4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 3/4
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_1_1.4' || fittingId === 'Nak_Gaika_1_1.2' || fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_1_1.4' || fittingId === 'Shaib_Nar_Rezba_1_1.2' || fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для трубы 60.3мм ==========
  if (mainPipeDiameter === 60.3) {
    // Ниппели: запрещены больше 1
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: только Ду25 (труба 33,7 мм — как ниппель 1")
    if (category === 'Фланцы') {
      return fittingId.startsWith('Flanec_25_');
    }

    // Накидные гайки: запрещены больше 1 1/2"
    if (category === 'Накидные гайки') {
      if (fittingId === 'Nak_Gaika_2') {
        return false;
      }
      return true;
    }

    // Шайбы с наружной резьбой: запрещены больше 1 1/2"
    if (category === 'Шайбы с наружной резьбой') {
      if (fittingId === 'Shaib_Nar_Rezba_2') {
        return false;
      }
      return true;
    }
  }

  // ========== Ограничения для трубы 76.1мм ==========
  if (mainPipeDiameter === 76.1) {
    // Ниппели: запрещены больше 1 1/2
    if (category === 'Ниппели') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4", 1 1/2"
      // Запрещены: 2", 2 1/2", 3", 4"
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/4
    if (category === 'Муфты') {
      // Разрешены: 1/4", 3/8", 1/2", 3/4", 1", 1 1/4"
      // Запрещены: 1 1/2", 2"
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду40
    if (category === 'Фланцы') {
      // Разрешены: Ду32, Ду40 (все варианты: galv, ss, ss_stamped, welded)
      // Запрещены: Ду50, Ду65, Ду80, Ду100, Ду125, Ду150
      const allowedFlanges = [
        'Flanec_25_galv', 'Flanec_25_ss', 'Flanec_25_ss_stamped', 'Flanec_25_welded',
        'Flanec_32_galv', 'Flanec_32_ss', 'Flanec_32_ss_stamped', 'Flanec_32_welded',
        'Flanec_40_galv', 'Flanec_40_ss', 'Flanec_40_ss_stamped', 'Flanec_40_welded',
      ];
      return allowedFlanges.includes(fittingId);
    }

    // Накидные гайки и шайбы с наружной резьбой: разрешены все
  }

  // ========== Ограничения для трубы 88.9мм ==========
  if (mainPipeDiameter === 88.9) {
    // Ниппели: запрещены больше 2
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/2
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 101.6мм ==========
  if (mainPipeDiameter === 101.6) {
    // Ниппели: запрещены больше 2
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 114.3мм ==========
  if (mainPipeDiameter === 114.3) {
    // Ниппели: запрещены больше 2 1/2
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду65
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 129мм ==========
  if (mainPipeDiameter === 129) {
    // Ниппели: запрещены больше 3
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду80
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 139.7мм ==========
  if (mainPipeDiameter === 139.7) {
    // Ниппели: запрещены больше 3
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду80
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 159мм ==========
  if (mainPipeDiameter === 159) {
    // Ниппели: запрещены больше 4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3', 'Nippel_4'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для трубы 168.3мм ==========
  if (mainPipeDiameter === 168.3) {
    // Ниппели: запрещены больше 4
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2', 'Nippel_3', 'Nippel_4'];
      return allowedNippels.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 219.1мм ==========
  if (mainPipeDiameter === 219.1) {
    // Фланцы: запрещены больше Ду125
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 273мм ==========
  if (mainPipeDiameter === 273) {
    // Фланцы: запрещены больше Ду150
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125')|| fittingId.startsWith('Flanec_150')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 323.9мм ==========
  if (mainPipeDiameter === 323.9) {
    // Фланцы: запрещены больше Ду200
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 355.6мм ==========
  if (mainPipeDiameter === 355.6) {
    // Фланцы: запрещены больше Ду200
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200')) {
        return true;
      }
      return false;
    }
  }

  // ========== Ограничения для гребенки 406.4мм ==========
  if (mainPipeDiameter === 406.4) {
    // Фланцы: запрещены больше Ду250
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100') || fittingId.startsWith('Flanec_125') || fittingId.startsWith('Flanec_150') || fittingId.startsWith('Flanec_200') || fittingId.startsWith('Flanec_250')) {
        return true;
      }
      return false;
    }
  }

  // Для остальных диаметров - все разрешено
  return true;
};

/**
 * Проверяем совместимость фитинга с квадратным профилем
 * 
 * @param {string} fittingId - ID фитинга
 * @param {string} profile - Профиль трубы (например, '60x60', '80x80')
 * @returns {boolean} - true если фитинг совместим с профилем
 */
export const isFittingCompatibleWithSquareProfile = (fittingId, profile) => {
  const fittingData = fittingsData[fittingId];
  if (!fittingData) return true;

  const category = fittingData.category;

  // ========== Ограничения для профиля 40x40 ==========
  if (profile === '40x40') {
    // Ниппели: запрещены больше 1"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 3/4"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1 1/2"
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1', 'Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2'];
      return allowedNakGaikas.includes(fittingId);
    }

    // Шайбы с наружной резьбой: запрещены больше 1 1/2"
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1', 'Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2'];
      return allowedShaibas.includes(fittingId);
    }
  }

  // ========== Ограничения для профиля 60x60 ==========
  if (profile === '60x60') {
    // Ниппели: запрещены больше 1 1/4"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду32
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 50x50 ==========
  if (profile === '50x50') {
    // Ниппели: запрещены больше 1"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 3/4"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены все
    if (category === 'Фланцы') {
      return false;
    }

    // Накидные гайки: запрещены больше 1 1/2"
    if (category === 'Накидные гайки') {
      const allowedNakGaikas = ['Nak_Gaika_1.2', 'Nak_Gaika_3.4', 'Nak_Gaika_1', 'Nak_Gaika_1_1.4', 'Nak_Gaika_1_1.2'];
      return allowedNakGaikas.includes(fittingId);
    }

    // Шайбы с наружной резьбой: запрещены больше 1 1/2"
    if (category === 'Шайбы с наружной резьбой') {
      const allowedShaibas = ['Shaib_Nar_Rezba_1.2', 'Shaib_Nar_Rezba_3.4', 'Shaib_Nar_Rezba_1', 'Shaib_Nar_Rezba_1_1.4', 'Shaib_Nar_Rezba_1_1.2'];
      return allowedShaibas.includes(fittingId);
    }
  }

  // ========== Ограничения для профиля 80x80 ==========
  if (profile === '80x80') {
    // Ниппели: запрещены больше 2"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_1_1.2', 'Nippel_2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 1 1/2"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду50
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 100x100 ==========
  if (profile === '100x100') {
    // Ниппели: запрещены больше 2 1/2"
    if (category === 'Ниппели') {
      const allowedNippels = ['Nippel_1.4', 'Nippel_3.8', 'Nippel_1.2', 'Nippel_3.4', 'Nippel_1', 'Nippel_1_1.4', 'Nippel_1_1.2', 'Nippel_2', 'Nippel_2_1/2'];
      return allowedNippels.includes(fittingId);
    }

    // Муфты: запрещены больше 2"
    if (category === 'Муфты') {
      const allowedMuftas = ['Mufta_1.4', 'Mufta_3.8', 'Mufta_1.2', 'Mufta_3.4', 'Mufta_1', 'Mufta_1_1.4', 'Mufta_1_1.2', 'Mufta_2'];
      return allowedMuftas.includes(fittingId);
    }

    // Фланцы: запрещены больше Ду65
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || fittingId.startsWith('Flanec_65')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // ========== Ограничения для профиля 150x150 ==========
  if (profile === '150x150') {
    // Ниппели: разрешены все
    if (category === 'Ниппели') {
      return true;
    }

    // Муфты: разрешены все
    if (category === 'Муфты') {
      return true;
    }

    // Фланцы: запрещены больше Ду100
    if (category === 'Фланцы') {
      if (fittingId.startsWith('Flanec_25_') || fittingId.startsWith('Flanec_32') || fittingId.startsWith('Flanec_40') || fittingId.startsWith('Flanec_50') || 
          fittingId.startsWith('Flanec_65') || fittingId.startsWith('Flanec_80') || fittingId.startsWith('Flanec_100')) {
        return true;
      }
      return false;
    }

    // Накидные гайки: разрешены любые
    if (category === 'Накидные гайки') {
      return true;
    }

    // Шайбы с наружной резьбой: разрешены любые
    if (category === 'Шайбы с наружной резьбой') {
      return true;
    }
  }

  // Для неизвестных профилей - все разрешено
  return true;
};

